import React, { useMemo, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { prop } from 'ramda';
import { useAppSelector } from 'js/store/hooks';
import { Link } from 'js/components/common/Link';

import style from './BottomNavigation.scss';

export const BottomNavigation = () => {
    const { pathname, hash } = useLocation();
    const menuItems = useAppSelector(prop('menuItems'));

    const hashPage = hash && hash.split('/')[0];

    const bottomMenu = useMemo(() => menuItems.find(item => item.name === 'BottomMenu')?.children, [menuItems]);
    const isItemActive = useCallback((url) => {
        const [itemPath = '', itemHash = ''] = url?.split?.('#') || [];
        const itemHashPage = itemHash && itemHash.split('/')[0];
        const itemCleanUrl = itemHashPage ? [itemPath, itemHashPage].join('#') : itemPath;

        return pathname + hashPage === itemCleanUrl;
    }, [pathname, hashPage]);

    return (
        <div className={`${style.container} bottom-navigation`}>
            {bottomMenu?.map(item => {
                const isActive = isItemActive(item.url);
                const linkClassName = [style.link, ...isActive ? [style.active] : []].join(' ');
                const bgUrl = `/library/BottomMenu/${item.menuIcon}${isActive ? '_active' : ''}.svg`;

                return (
                    <Link key={item.name} href={item.url} className={linkClassName}>
                        <span
                            className={style.icon}
                            style={{ backgroundImage: `url("${bgUrl}")` }}
                        />
                        <span className={style.title}>{item.title}</span>
                    </Link>
                );
            })}
        </div>
    );
};
